import { ReactElement } from "react";
import styles from "./Loading.module.css";
import { Box, Typography } from "@mui/material";

export const LoadingIndicator = function ({
  children,
  show,
  small = false,
  text
}: {
  show?: boolean;
  children?: React.ReactNode;
  small?: boolean;
  text?:string;
}): ReactElement {
  return show === true ? (
    small ==false ?
    <Box>
      <div className={styles.loaderContainer}>
        <div className={styles.loader}></div>
      </div>
      <Box sx={{display:'flex'}}><Box sx={{margin:'auto'}}>{text}</Box></Box>
    </Box>
    :
    <div className={styles.smallLoaderContainer}>
    <div className={styles.smallLoader}></div>
  </div>
  ) : (
    <>{children}</>
  );
};
